import client from "./axios";

const k8sClientUrl = `${window.__env.GATEWAY_URL}/v1/k8s`;

export const K8sClient = {
  getServiceLogs: (bdaId: number, workflowId: number, serviceId: number, params?: URLSearchParams) => (
    client.get(`${k8sClientUrl}/logs/${bdaId}/${workflowId}/${serviceId}`, { params })
  ),
  restartService: (bdaId: number, workflowId: number, serviceId: number, params?: URLSearchParams) => (
    client.post(`${k8sClientUrl}/retry/${bdaId}/${workflowId}/${serviceId}`, {}, { params }) // {k8sRunId,namespace}
  ),
  downloadServiceLogs: (bdaId: number, workflowId: number, serviceId: number, params?: URLSearchParams) => (
    client.get(`${k8sClientUrl}/logs/${bdaId}/${workflowId}/${serviceId}`, { params, responseType: 'blob' })
  ),
  downloadServiceAsset: (bdaId: number, workflowId: number, serviceId: number, params?: URLSearchParams) => (
    client.get(`${k8sClientUrl}/assets/${bdaId}/${workflowId}/${serviceId}`, { params, responseType: 'blob' })
  )
}